import { InstallHint } from "../components/InstallHint";
import { YarnLogo } from "../components/YarnLogo";
import { useEffect } from "react";
import { Link } from "react-router-dom";

import { isNonProductionApp } from "../config/app-environment";
import { SeriesShelf } from "../components/SeriesShelf";
import { BOOKS, mediumWords, pageTitle, SERIES, SITE_TAGLINE } from "../config/site";

/** A one-off goes under Books or Movies, by what it is. A series can mix both. */
const standaloneIn = (whole: string) => SERIES.filter((series) => series.standalone === true
  && BOOKS.some((book) => book.seriesId === series.id && mediumWords(book).whole === whole));

const seriesGroups = [
  { title: "Series", series: SERIES.filter((series) => !series.standalone) },
  { title: "Books", series: standaloneIn("book") },
  { title: "Movies", series: standaloneIn("movie") },
];

export function LandingPage() {
  const showInternalLinks = isNonProductionApp();
  useEffect(() => {
    document.title = pageTitle("Interactive story timelines");
  }, []);

  return (
    <div className="landing">
      <InstallHint />
      <h1 className="landing-title"><YarnLogo /></h1>
      <p className="landing-lead">{SITE_TAGLINE}</p>
      {seriesGroups.map((group) => group.series.length === 0 ? null : (
        <section className="landing-books" key={group.title} aria-label={group.title}>
          <h2 className="book-section-title">{group.title}</h2>
          {group.series.map((series) => (
            <SeriesShelf key={series.id} series={series} heading={!series.standalone} />
          ))}
        </section>
      ))}

      {showInternalLinks ? (
        <footer className="landing-footer">
          <Link className="landing-footer__link" to="/status">
            Deploy status
          </Link>
          {import.meta.env.DEV ? (
            <Link className="landing-footer__link" to="/admin">
              Images
            </Link>
          ) : null}
        </footer>
      ) : null}
    </div>
  );
}
